import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withFieldWrapper from '../hocs/withFieldWrapper';
import moment from 'moment';
import MaskedTextInput from "react-text-mask";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';

registerLocale('ru', ru);

import "react-datepicker/dist/react-datepicker.css";

import { DATE_FORMAT, API_DATE_FORMAT } from '../../constants/date';
import LanguageContext from '../LanguageContext';

class DatepickerComponent extends Component {
    static propTypes = {
        input: PropTypes.object,
        onChange: PropTypes.func,
        min: PropTypes.object,
        max: PropTypes.object,
        placeholder: PropTypes.string
    };

    onChange = date => {
        this.props.onChange(date ? moment(date).format(API_DATE_FORMAT) : null);
    }

    render() {
        const { input: { value }, placeholder, min, max } = this.props;

        return <LanguageContext.Consumer>
            { language =>
                <DatePicker
                    selected={value ? moment(value, API_DATE_FORMAT).toDate() : null}
                    onChange={this.onChange}
                    dateFormat={DATE_FORMAT}
                    locale={language}
                    minDate={min ? min.toDate() : null}
                    maxDate={max ? max.toDate() : null}
                    placeholderText={placeholder}
                    customInput={
                        <MaskedTextInput
                            className='ant-input'
                            type='text'
                            mask={[/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/]}
                        />
                    }
                    />
            }
        </LanguageContext.Consumer>;
    }
}

export default withFieldWrapper(DatepickerComponent);
